<template>
    <b-row>
        <b-col lg="12" class="px-0">
            <h4 class="text-muted">รายละเอียด{{ 
                indexSelected === 0 
                ? 'ต้นทาง' 
                : indexSelected === form.routes.length - 1 
                    ? 'ปลายทาง' 
                    : `ระหว่างทาง จุดที่ ${indexSelected}`
                }}
            </h4>
        </b-col>
        <b-col lg="6">
            <b-form-group 
                label="สถานที่"
            >
                <b-form-input
                    placeholder="สถานที่"
                    v-model="form.routes[indexSelected].name"
                    disabled
                />
            </b-form-group>
        </b-col>
        <b-col lg="6">
            <b-form-group 
                label="ไมล์เริ่มงาน"
            >
                <b-form-input
                    placeholder="ไมล์เริ่มงาน"
                    v-model="form.routes[indexSelected].mile"
                    disabled
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" class="my-2" v-for="detail in routeDetails" :key="detail.key">
            <b-list-group>
                <b-list-group-item
                    class="d-flex justify-content-between align-items-center py-3"
                    role="tab"
                    href="javascript:;"
                    v-b-toggle="`route-${detail.key}`"
                >
                    <span class="h3">
                        <i 
                            class="text-primary" 
                            :class="'fas fa-circle-thin'"
                        />
                        {{ getTypeimageRoute(detail.key).title }} <small class="text-muted">({{ detail.images.length }} รูป)</small>
                    </span>
                    <i
                        class="ni"
                        :class="
                            form.routes[indexSelected].visible ? 'ni-bold-up' : 'ni-bold-down'
                    "></i>
                </b-list-group-item>
                <b-collapse :id="`route-${detail.key}`">
                    <b-card no-body>
                        <b-card-body>
                            <b-row v-if="detail.images.length > 0">
                                <b-col cols="3" v-for="image in detail.images" :key="`${detail.key}_${image.id}`">
                                    <img :src="image.image" :alt="detail.key" class="image-max-size" />
                                </b-col>
                            </b-row>
                            <b-row class="my-3" v-else>
                                <b-col cols="12" class="text-center">
                                    <h5 class="text-muted">ไม่มีรูปภาพให้แสดง</h5>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-collapse>
            </b-list-group>
        </b-col>
    </b-row>
</template>

<script>
import jobServices from "@/api/job.service.js";
import { 
    getTypeimageRoute, 
    TYPE_IMAGE_MILE,
    TYPE_IMAGE_INVOICE,
    TYPE_IMAGE_PRODUCT
} from "@/util/constants.js" 

export default {
    props: {
        form: {
            type: Object
        },
        indexSelected: {
            type: Number,
        }
    },
    data(){
        return{
            getTypeimageRoute,
            routeDetails: [
                { key: TYPE_IMAGE_MILE, images: [] },
                { key: TYPE_IMAGE_INVOICE, images: [] },
                { key: TYPE_IMAGE_PRODUCT, images: [] },
            ]
        }
    },
    mounted(){
        this.getImageByRoute();
    },  
    methods: {
        async getImageByRoute(){
            const { data } = await jobServices.getImageByJobRouteId({
                job_route_id: this.form.routes[this.indexSelected].id
            })

            if(data.data){
                this.routeDetails = data.data;
            }
        }
    },
    watch: {
        indexSelected: function () {
            this.getImageByRoute()
        }
    }
}
</script>
